const translations = {
  en_GB: {
    YOU_ARE_ALREAD_LOGGED_IN: 'You are already logged in.',
    CLICK_HERE: 'Please click here',
    TO_RELOAD: 'to reload your content access'
  },
  en_US: {},
  fr_FR: {
    YOU_ARE_ALREAD_LOGGED_IN: 'Vous êtes déjà connecté.',
    CLICK_HERE: 'Veuillez cliquer ici',
    TO_RELOAD: 'pour recharger votre accès au contenu.'
  },
  it_IT: {
    YOU_ARE_ALREAD_LOGGED_IN: "Hai già effettuato l'accesso.",
    CLICK_HERE: 'Fai clic qui',
    TO_RELOAD: "per ricaricare l'accesso ai contenuti"
  },
  de_DE: {
    YOU_ARE_ALREAD_LOGGED_IN: 'Sie sind bereits angemeldet.',
    CLICK_HERE: 'Bitte klicken Sie hier',
    TO_RELOAD: 'um Ihren Inhaltszugriff neu zu laden'
  }
};

export default translations;
